import { restrictions } from 'state/features-list/constants';

export enum MyCareRoutes {
  MY_CARE_HUB = 'myCareHub',
  MY_CARE_OTHER_SERVICES = 'myCareOtherServices',
  MY_CARE_ASSESMENT_RESULTS = 'myCareAssessments',
  BOOK_APPOINTMENT = 'bookAppointment',
  CHAT = 'tmhChat',
  CARE_PATH_HOME = 'carePathHome',
}

export const CarePathRestrictions = {
  user: [
    restrictions.digital_programs_self_signup,
    restrictions.eap_self_assessment,
  ],
  operator: 'OR' as const,
};
